<div class="card">

  <div class="card-header">
    {{ ( isOfferList() ? 'INSURANCE_OFFER_LIST' : 'INSURANCE_LIST') | translate }}
    <div class="card-actions">
      <a class="btn-setting table-header-action-button d-flex align-items-center px-1 w-auto font-weight-normal"
         title="{{'ATTACHMENT_DOWNLOAD_TITLE' | translate}}"
         (click)="downloadZip()" *ngIf="!isOfferList()">
        <i class="icomoon pr-1 icomoon-download"></i>
        <span class="breadcrumb-button-text-visible">{{ 'ATTACHMENT_DOWNLOAD_TITLE' | translate }}</span>
      </a>
      <a class="btn-setting table-header-action-button d-flex align-items-center px-1 w-auto font-weight-normal"
         title="{{'CLIENT_DOCUMENT_MERGED_DOWNLOAD_TITLE' | translate}}"
         (click)="downloadMergedZip()" *ngIf="!isOfferList()">
        <i class="icomoon pr-1 icomoon-download"></i>
        <span class="breadcrumb-button-text-visible">{{ 'CLIENT_DOCUMENT_MERGED_DOWNLOAD_TITLE' | translate }}</span>
      </a>
      <a class="btn-setting table-header-action-button d-flex align-items-center px-1 w-auto font-weight-normal"
         title="{{'COMMON_BUTTON_EMAIL' | translate}}"
         (click)="openEmailDialog()" *ngIf="!isOfferList()">
        <i class="icomoon pr-1 icomoon-email-send"></i>
        <span class="breadcrumb-button-text-visible">{{ 'COMMON_BUTTON_EMAIL' | translate }}</span>
      </a>
      <a class="btn-setting table-header-action-button d-flex align-items-center px-1 w-auto font-weight-normal"
         title="{{'COMMON_BUTTON_EMAIL' | translate}}"
         (click)="tryOfferEmailResend()" *ngIf="isOfferList() && anySelected()">
        <i class="icomoon pr-1 icomoon-email-send"></i>
        <span class="breadcrumb-button-text-visible">{{ 'COMMON_BUTTON_EMAIL' | translate }}</span>
      </a>
      <a class="btn-setting cursor-pointer" (click)="toggleSearch()"
         title="{{'COMMON_SHOW_SEARCH_HINT' | translate}}">
        <i #searchIcon class="icomoon icomoon-search"></i>
      </a>
    </div><!-- /.card-actions -->
  </div>
  <div class="card-body border-bottom" *ngIf="showSearch" appHighlightContainer>
    <app-dql-search-container #dqlSearchContainer
                              (onSearch)="onDqlSearchClicked()"
                              [rightModel]="rightModel"
                              [dqlStoredQueryArgs]="dqlStoredArgs"
                              [dialogContainer]="dqlDialogHolder"
                              [isTyped]="true">
    </app-dql-search-container>
  </div>
  <div class="card-body">

    <table class="table table-striped table-bordered">
      <thead>
      <tr>
        <th class="table-sorter-header w-5 hidden-xs-down">
          <app-animated-checkbox [selected]="allInsurancesSelected"
                                 (clickEvent)="allSelected()"></app-animated-checkbox>
        </th>
        <th class="table-sorter-header" *ngIf="!isOfferList()">
          <app-table-field-sorter [orderField]="ClientDocument.OrderField.EXTERNAL_ID"
                                  [orderType]="queryModel.getOrderType(ClientDocument.OrderField.EXTERNAL_ID)"
                                  (orderChange)="orderBy($event)"
                                  [text]="'INSURANCE_LIST_TABLE_HEADER_EXTERNAL_ID' | translate"></app-table-field-sorter>
        </th>
        <th class="table-sorter-header" *ngIf="isOfferList()">
          <app-table-field-sorter [orderField]="ClientDocument.OrderField.OFFER_ID"
                                  [orderType]="queryModel.getOrderType(ClientDocument.OrderField.OFFER_ID)"
                                  (orderChange)="orderBy($event)"
                                  [text]="'INSURANCE_LIST_TABLE_HEADER_OFFER_ID' | translate"></app-table-field-sorter>
        </th>
        <th class="table-sorter-header hidden-sm-down">
          <app-table-sorter-no-op
            [text]="'INSURANCE_LIST_TABLE_HEADER_SPONSOR' | translate"></app-table-sorter-no-op>
        </th>
        <th class="table-sorter-header hidden-sm-down">
          <app-table-sorter-no-op
            [text]="'INSURANCE_LIST_TABLE_HEADER_CLIENT_NAME' | translate"></app-table-sorter-no-op>
        </th>
        <th class="table-sorter-header hidden-sm-down">
          <app-table-sorter-no-op
            [text]="'INSURANCE_LIST_TABLE_HEADER_INSURANCE_DETAILS' | translate"></app-table-sorter-no-op>
        </th>
        <th class="table-sorter-header hidden-md-down">
          <app-table-sorter-no-op
            [text]="'INSURANCE_LIST_TABLE_HEADER_SUBMITTER_NAME' | translate"></app-table-sorter-no-op>
        </th>
        <th class="table-sorter-header hidden-md-down">
          <app-table-field-sorter [orderField]="ClientDocument.OrderField.EVENT_TIME"
                                  [orderType]="queryModel.getOrderType(ClientDocument.OrderField.EVENT_TIME)"
                                  (orderChange)="orderBy($event)"
                                  [text]="(isOfferList() ? 'INSURANCE_LIST_TABLE_HEADER_OFFER_TIME' : 'INSURANCE_LIST_TABLE_HEADER_SUBMIT_TIME') | translate"></app-table-field-sorter>
        </th>
        <th class="table-sorter-header w-table-options-menu">
          <app-table-sorter-no-op
            [text]="'INSURANCE_LIST_TABLE_HEADER_PDF_DOWNLOAD' | translate"></app-table-sorter-no-op>
        </th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let insurance of insuranceList | paginate: {
                      id: pagingId,
                      itemsPerPage: queryModel.itemsPerPage,
                      currentPage: queryModel.currentPage,
                      totalItems: queryModel.currentNumberOfItems }">
        <td class="hidden-xs-down">
          <app-animated-checkbox (clickEvent)="toggleSelected(insurance.id)"
                                 [selected]="isSelected(insurance.id)"></app-animated-checkbox>
        </td>
        <td>
          <i class="icomoon icomoon-trash icomoon-disable-table" *ngIf="insurance.deleted && insurance.deletionCause"
             [popover]="deletionData" triggers="mouseenter:mouseleave"></i>
          <ng-template #deletionData>
            {{ insurance.deletionCause }}<br/>
            {{ insurance.deletionDate.toUtcIsoString() | date:'shortDate' }}
          </ng-template>
          <i class="icomoon icomoon-trash icomoon-disable-table" *ngIf="insurance.deleted && !insurance.deletionCause"></i>
          {{ insurance.externalId }}
        </td>
        <td class="hidden-sm-down">{{ insurance.sponsorName }}</td>
        <td class="hidden-sm-down">{{ insurance.clientName }}</td>
        <ng-template #paymentTypePopover>
          <i class="icomoon {{getPaymentTypeIcon(insurance.paymentTypeCode)}}"></i>
          {{ insurance.paymentTypeText }}
        </ng-template>
        <td class="hidden-sm-down">
          {{ insurance.insuranceProductType }} - {{ insurance.insuranceMode }}
          - {{ insurance.insuranceLevel }} {{ 'INSURANCE_LEVEL' | translate }}
          <i class="icomoon {{getPaymentTypeIcon(insurance.paymentTypeCode)}}" [popover]="paymentTypePopover"
             triggers="mouseenter:mouseleave"></i>
        </td>
        <td class="hidden-md-down">{{ insurance.creatorName }}</td>
        <td class="hidden-md-down">{{ insurance.submitTime.toUtcIsoString() | date:'short' }}</td>
        <td>
          <a *ngIf="insurance.hasPdf" class="icons-table-group" (click)="downloadPdf(insurance.id)">
            <i class="icomoon icons-table-item icomoon-download icomoon-modify-table cursor-pointer"
               title="{{'COMMON_BUTTON_DOWNLOAD' | translate}}"></i>
          </a>
        </td>
      </tr>
      </tbody>
      <tfoot>
      <tr>
        <th class="table-sorter-header w-5 hidden-xs-down">
          <app-animated-checkbox [selected]="allInsurancesSelected"
                                 (clickEvent)="allSelected()"></app-animated-checkbox>
        </th>
        <th class="table-sorter-header" *ngIf="!isOfferList()">
          <app-table-field-sorter [orderField]="ClientDocument.OrderField.EXTERNAL_ID"
                                  [orderType]="queryModel.getOrderType(ClientDocument.OrderField.EXTERNAL_ID)"
                                  (orderChange)="orderBy($event)"
                                  [text]="'INSURANCE_LIST_TABLE_HEADER_EXTERNAL_ID' | translate"></app-table-field-sorter>
        </th>
        <th class="table-sorter-header" *ngIf="isOfferList()">
          <app-table-field-sorter [orderField]="ClientDocument.OrderField.OFFER_ID"
                                  [orderType]="queryModel.getOrderType(ClientDocument.OrderField.OFFER_ID)"
                                  (orderChange)="orderBy($event)"
                                  [text]="'INSURANCE_LIST_TABLE_HEADER_OFFER_ID' | translate"></app-table-field-sorter>
        </th>
        <th class="table-sorter-header hidden-sm-down">
          <app-table-sorter-no-op
            [text]="'INSURANCE_LIST_TABLE_HEADER_SPONSOR' | translate"></app-table-sorter-no-op>
        </th>
        <th class="table-sorter-header hidden-sm-down">
          <app-table-sorter-no-op
            [text]="'INSURANCE_LIST_TABLE_HEADER_CLIENT_NAME' | translate"></app-table-sorter-no-op>
        </th>
        <th class="table-sorter-header hidden-sm-down">
          <app-table-sorter-no-op
            [text]="'INSURANCE_LIST_TABLE_HEADER_INSURANCE_DETAILS' | translate"></app-table-sorter-no-op>
        </th>
        <th class="table-sorter-header hidden-md-down">
          <app-table-sorter-no-op
            [text]="'INSURANCE_LIST_TABLE_HEADER_SUBMITTER_NAME' | translate"></app-table-sorter-no-op>
        </th>
        <th class="table-sorter-header hidden-md-down">
          <app-table-field-sorter [orderField]="ClientDocument.OrderField.EVENT_TIME"
                                  [orderType]="queryModel.getOrderType(ClientDocument.OrderField.EVENT_TIME)"
                                  (orderChange)="orderBy($event)"
                                  [text]="(isOfferList() ? 'INSURANCE_LIST_TABLE_HEADER_OFFER_TIME' : 'INSURANCE_LIST_TABLE_HEADER_SUBMIT_TIME') | translate"></app-table-field-sorter>
        </th>
        <th class="table-sorter-header w-table-options-menu">
          <app-table-sorter-no-op
            [text]="'INSURANCE_LIST_TABLE_HEADER_PDF_DOWNLOAD' | translate"></app-table-sorter-no-op>
        </th>
      </tr>
      </tfoot>
    </table>

    <app-table-paging
      [id]="pagingId"
      [currentNumberOfItems]="queryModel.currentNumberOfItems"
      [totalNumberOfItems]="queryModel.totalNumberOfItems"
      [itemsPerPage]="queryModel.itemsPerPage"
      (pageChange)="pageChanged($event)"
      (itemsPerPageChange)="itemsPerPageChanged($event)">
    </app-table-paging>

  </div><!-- /.card-body -->

</div><!-- /.card -->

